// Generated using typescript-generator version null on 2019-05-27 14:47:46.

import { NeqHttpClient as HttpClient } from './http-client.config';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CalculationStatus } from '@sharedcommon/model/calculation-status.model';
import { CoherenceCalcRequestDto, CoherenceCalcRequestInputDto, ComputeWithMetaDataDto } from './data.restservice';
import { URN } from '@sharedcommon/model/urn.model';
import { AnalysisOriginDto } from '@sharedcommon/model/sample/analysis-origin.model';
import { environment } from '@sharedenvironment';

export class TechnicalMetaDto {
  key?: string;
  value?: string;
}

export class CalcRequestDto extends CoherenceCalcRequestDto {
  activityCode?: string;
  productId: string;
  referenceId: string;
  predictionModelId: string;
  inputs?: CalcRequestInputDto[];
  forValuesSuggestions: boolean;
  referenceCode: string;
  entityPrincipalMatrixIdentifier: string;
}

export class CalcRequestInputDto extends CoherenceCalcRequestInputDto {
  analysisOrigin?: AnalysisOriginDto;
}

export class ComputeDto {
  id?: string;
  status: Status;
  report?: string;
  results?: ComputeResultDto[];
  createdBy?: string;
  creationDate?: any;
  calculationStatus: CalculationStatus ;
  forcedCalcStatus: boolean ;
}

export class ComputeResultDto {
  id?: string;
  computeId?: string;
  rawMaterialId: string;
  nutrientId?: string;
  nutrientCode?: string;
  matrix: URN;
  value: number;
  standard?: boolean;
  filled?: boolean;
}

@Injectable()
export class TechnicalServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /technical/metas/{key}
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getMeta
   */
  getMeta(key: string): RestResponse<TechnicalMetaDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/metas/${key}` });
  }

  /**
   * HTTP GET /technical/rights
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getRights
   */
  getRights(): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/rights` });
  }
}

@Injectable()
export class EquationManagerServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Calculate nutrient calculated value
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP POST /equations
   * Java method: com.neovia.equadvice.equation.manager.service.EquationManagerService.calculate
   */
  calculate(arg0: CalcRequestDto): RestResponse<ComputeWithMetaDataDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`equations`, data: arg0 });
  }

  /**
   * Calculate nutrient entry value
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP POST /equations/entry
   * Java method: com.neovia.equadvice.equation.manager.service.EquationManagerService.calculateEntry
   */
  calculateEntry(arg0: CalcRequestDto): RestResponse<ComputeDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`equations/entry`, data: arg0 });
  }
}

export type RestResponse<R> = Observable<R>;

export type Status = 'STARTED' | 'FAILED' | 'FINISHED' | 'SAVED' | 'UNPROCESSED';

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = environment.equationManager.baseUrl;
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}
